import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Box,
    Link,
    MenuItem,
    Menu,
    Skeleton,
    Typography,
} from '@mui/material';
import { BackArrowIcon } from '../icons';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { GlobalStyles } from '@mui/material';
import ReferBonusManagementData from '../components/ReferBonusManagement/Data';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { FilterImgIcon } from '../icons';
import EditBonusModal from '../components/ReferBonusManagement/EditBonusModal';
import ActiveBonusModal from '../components/ReferBonusManagement/ActiveBonusModal';
import DeactiveBonusModal from '../components/ReferBonusManagement/DeactiveBonusModal';

const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 37,
    height: 21,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#1075FF',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#1075FF',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#1075FF',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 17,
        height: 17,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));


const ReferBonusManagement = () => {
    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [selectedRow, setSelectedRow] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [searchText, setSearchText] = React.useState('');

    React.useEffect(() => {
        setTimeout(() => {
            setRows(ReferBonusManagementData);
            setLoading(false);
        }, 2000);
    }, []);

    const handleClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };

    const handleMenuAction = (action) => {
        console.log(`Action "${action}" clicked for row:`, selectedRow);
        handleClose();
    };

    //edit Bonus Modal//
    const [openEdit, setOpenEdit] = React.useState(false);

    const handleClickOpenEdit = () => {
        setOpenEdit(true);
    };
    const handleCloseOpenEdit = () => {
        setOpenEdit(false);
    };

    //active Bonus//

    const [openActive, setOpenActive] = React.useState(false);

    const handleClickOpenActive = () => {
        setOpenActive(true);
    };
    const handleCloseOpenActive = () => {
        setOpenActive(false);
    };

    //deactive Bonus//

    const [openDeactive, setOpenDeactive] = React.useState(false);

    const handleClickOpenDeactive = () => {
        setOpenDeactive(true);
    };
    const handleCloseOpenDeactive = () => {
        setOpenDeactive(false);
    };


    const filteredRows = rows.filter((row) => {
        const matchesSearch = row.name?.toLowerCase().includes(searchText.toLowerCase()) || row.universityId?.toLowerCase().includes(searchText.toLowerCase());
        return matchesSearch;
    });

    //switch enable , disable state//
    React.useEffect(() => {
        setTimeout(() => {
            const updatedRows = ReferBonusManagementData.map((row) => ({
                ...row,
                isUGEnabled: true,   // default UG state
                isPGEnabled: false,  // default PG state
                isDBEnabled: false,  // default DB state
            }));
            setRows(updatedRows);
            setLoading(false);
        }, 2000);
    }, []);


    const handleUGSwitchChange = (rowId) => {
        const updatedRows = rows.map((row) =>
            row.id === rowId ? { ...row, isUGEnabled: !row.isUGEnabled } : row
        );
        setRows(updatedRows);
    };

    const handlePGSwitchChange = (rowId) => {
        const updatedRows = rows.map((row) =>
            row.id === rowId ? { ...row, isPGEnabled: !row.isPGEnabled } : row
        );
        setRows(updatedRows);
    };

    const handleDBSwitchChange = (rowId) => {
        const updatedRows = rows.map((row) =>
            row.id === rowId ? { ...row, isDBEnabled: !row.isDBEnabled } : row
        );
        setRows(updatedRows);
    };



    const columns = [
        {
            field: 'serial',
            headerName: 'S. No.',
            width: 60,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => filteredRows.findIndex((r) => r.id === params.row.id) + 1,
        },
        // Removed universityId field as per your comment
        {
            field: 'name',
            headerName: 'University',
            flex: 2,
            minWidth: 280,
            renderCell: (params) => {
                const { logo, name } = params.row;

                const getInitials = (fullName) => {
                    if (!fullName) return '';
                    const words = fullName.trim().split(' ').filter(Boolean);
                    if (words.length === 1) return words[0][0]?.toUpperCase() || '';
                    if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
                    return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
                };

                const stringToColor = (str) => {
                    let hash = 0;
                    for (let i = 0; i < str.length; i++) {
                        hash = str.charCodeAt(i) + ((hash << 5) - hash);
                    }
                    const c = (hash & 0x00ffffff).toString(16).toUpperCase();
                    return '#' + '00000'.substring(0, 6 - c.length) + c;
                };

                const bgColor = stringToColor(name || 'Course');

                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ cursor: 'pointer' }}
                    >
                        {logo ? (
                            <Box
                                component="img"
                                src={logo}
                                alt="logo"
                                sx={{
                                    width: 40,
                                    height: 40,
                                    padding: '5px',
                                    borderRadius: '50%',
                                    objectFit: 'contain',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                    display: 'block',
                                    maxHeight: 60,
                                }}
                            />
                        ) : (
                            <Box
                                sx={{
                                    minWidth: 35,
                                    minHeight: 35,
                                    maxWidth: 35,
                                    maxHeight: 35,
                                    borderRadius: '50%',
                                    backgroundColor: bgColor,
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 500,
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                }}
                            >
                                {getInitials(name)}
                            </Box>
                        )}
                        {params.value}
                    </Box>
                );
            },
        },
        {
            field: 'courser',
            headerName: 'UG Courser',
            flex: 1.5,
            minWidth: 190,
            cellClassName: 'sticky-col-1 text-center ',
            headerClassName: 'sticky-col-1 text-center leadcourcecenter',
            renderCell: (params) =>
                loading ? (
                    <Skeleton width={40} />
                ) : (
                    <FormControlLabel
                        sx={{ margin: '0' }}
                        control={
                            <IOSSwitch
                                sx={{ m: 1 }}
                                checked={params.row.isUGEnabled}
                                onChange={() => handleUGSwitchChange(params.row.id)}
                            />
                        }
                    />
                ),
        },
        {
            field: 'ugbonusAmount',
            headerName: 'UG Bonus Amt(₹)',
            flex: 1,
            minWidth: 190,
            cellClassName: 'sticky-col-1 text-center ',
            headerClassName: 'sticky-col-1 text-center leadcourcecenter',
            renderCell: (params) => {
                const color = params.row.isUGEnabled ? '#363853' : '#818181';
                return loading ? (
                    <Skeleton width={40} height={30} />
                ) : (
                    <Typography
                        sx={{
                            color,
                            fontWeight: '600',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                        }}
                    >
                        {params.value}
                    </Typography>
                );
            }
        },

        {
            field: 'pgCourser',
            headerName: 'PG Courser',
            flex: 1.5,
            minWidth: 190,
            cellClassName: 'sticky-col-1 text-center ',
            headerClassName: 'sticky-col-1 text-center leadcourcecenter',
            renderCell: (params) =>
                loading ? (
                    <Skeleton width={40} />
                ) : (
                    <FormControlLabel
                        sx={{ margin: '0' }}
                        control={
                            <IOSSwitch
                                sx={{ m: 1 }}
                                checked={params.row.isPGEnabled}
                                onChange={() => handlePGSwitchChange(params.row.id)}
                            />
                        }
                    />
                ),
        },
        {
            field: 'pgBonusAmt',
            headerName: 'PG Bonus Amt(₹)',
            flex: 1,
            minWidth: 190,
            cellClassName: 'sticky-col-1 text-center ',
            headerClassName: 'sticky-col-1 text-center leadcourcecenter',
            renderCell: (params) => {
                const color = params.row.isPGEnabled ? '#363853' : '#818181';

                return loading ? (
                    <Skeleton width={40} height={30} />
                ) : (
                    <Typography
                        sx={{
                            color,
                            fontWeight: '600',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                        }}
                    >
                        {params.value}
                    </Typography>
                );
            }
        },

        {
            field: 'doctorate',
            headerName: 'Doctorate',
            flex: 1.5,
            minWidth: 190,
            cellClassName: 'sticky-col-1 text-center ',
            headerClassName: 'sticky-col-1 text-center leadcourcecenter',
            renderCell: (params) =>
                loading ? (
                    <Skeleton width={40} />
                ) : (
                    <FormControlLabel
                        sx={{ margin: '0' }}
                        control={
                            <IOSSwitch
                                sx={{ m: 1 }}
                                checked={params.row.isDBEnabled}
                                onChange={() => handleDBSwitchChange(params.row.id)}
                            />
                        }
                    />
                ),
        },

        {
            field: 'doctorateBonusAmt',
            headerName: 'Doctorate Bonus Amt(₹)',
            flex: 1,
            minWidth: 190,
            cellClassName: 'sticky-col-1 text-center ',
            headerClassName: 'sticky-col-1 text-center leadcourcecenter',
            renderCell: (params) => {
                const color = params.row.isDBEnabled ? '#363853' : '#818181';

                return loading ? (
                    <Skeleton width={40} height={30} />
                ) : (
                    <Typography
                        sx={{
                            color,
                            fontWeight: '600',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                        }}
                    >
                        {params.value}
                    </Typography>
                );
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 100,
            cellClassName: 'sticky-col-1 text-center ',
            headerClassName: 'sticky-col-1 text-center leadcourcecenter',
            renderCell: (params) =>
                loading ? <Skeleton width={80} /> : <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', cursor: 'pointer' }} onClick={(event) => handleClick(event, params.row)} >
                    <FilterImgIcon />
                </Box>
        },
    ];
    return (
        <>
            {/* Apply global styles to DataGrid dropdown menus */}
            <GlobalStyles
                styles={{
                    '.MuiDataGrid-menuList': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiDataGrid-panelContent': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiSelect-select': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiList-root .MuiButtonBase-root': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-menuList .MuiTypography-root': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-menuList .MuiMenuItem-root': {
                        fontSize: '13px',
                        padding: '6px 12px',
                    },
                    '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                        backgroundColor: '#fff',
                    },
                    '& .MuiDataGrid-cell.sticky-col-1': {
                        position: 'sticky',
                        left: 0,
                        background: '#fff',
                        zIndex: 2,
                    },
                    '& .MuiDataGrid-columnHeader.sticky-col-1': {
                        position: 'sticky',
                        left: 0,
                        background: '#fff',
                        zIndex: 3, // slightly higher than cell
                    },
                }}
            />

            <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', }}>
                    <div className="row align-items-center">
                        <div className="col">
                            <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/" className='d-flex'><BackArrowIcon /></Link>Refer Bonus Management Page</Typography>
                        </div>
                    </div>
                    {/* End Col */}
                </div>
                {/* Filter Toolbar */}
                <Box sx={{ padding: '10px 15px', }}>
                    <Box sx={{ position: 'relative' }}>
                        <Box
                            sx={{
                                width: '100%',
                                marginBottom: '20px'
                            }}
                        >
                            <input
                                type="text"
                                placeholder="Search by University"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '6px 12px',
                                    borderRadius: '50px',
                                    border: '1px solid #ccc',
                                    height: '30px',
                                    fontSize: '12px',
                                }}
                            />
                        </Box>
                        <Box sx={{ position: 'absolute', top: '0', right: '20px' }}>
                            <SearchIcon />
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Box>
                            <Typography sx={{ fontSize: '14px', fontWeight: '500', color: '#000' }}>Refer Bounces Management</Typography>
                            <Box
                                sx={{
                                    fontSize: '12px',
                                    color: '#4b5563',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                    fontWeight: 500,
                                }}
                            >
                                <Typography component="span" sx={{ fontSize: '12px', }}>Showing</Typography>
                                <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600, }}>
                                    {filteredRows.length}
                                </Typography>
                                <Typography component="span">from</Typography>
                                <Typography component="span" sx={{ fontSize: '12px', fontWeight: 600 }}>
                                    {rows.length}
                                </Typography>
                                <Typography component="span" sx={{ fontSize: '12px', }}>results</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ background: '#EFEFEF', borderRadius: '8px', padding: '3px 14px', height: '39px' }}>
                            <Link style={{ color: '#363853', fontSize: '15px', fontWeight: '500', textDecoration: 'none' }}><FileUploadOutlinedIcon />  Export</Link>
                        </Box>
                    </Box>
                </Box>

                {/* Data Table */}
                <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                    <DataGrid
                        rows={filteredRows}
                        columns={columns}
                        loading={loading}
                        getRowHeight={() => 60}
                        // getRowHeight={({ model }) => (model.status === 'Draft' ? 90 : 60)}
                        initialState={{
                            pagination: { paginationModel: { page: 0, pageSize: 20 } },
                        }}
                        pageSizeOptions={[20, 50]}
                        checkboxSelection
                        disableRowSelectionOnClick
                        disableVirtualization
                        sx={{
                            border: 0,
                            '& .MuiDataGrid-footerContainer': {
                                justifyContent: 'center', // center pagination
                                padding: '8px 16px', display: 'none',
                            },
                            '& .MuiTablePagination-selectLabel': {
                                marginBottom: '0',
                            },
                            '& .MuiTablePagination-root': {
                                fontSize: '13px',
                            },
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                fontSize: '12px',
                                marginBottom: '0',
                            },
                            '& .MuiPaginationItem-root': {
                                borderRadius: '8px',
                                fontSize: '13px',
                                minWidth: '32px',
                                height: '32px',
                            },
                            '& .MuiTypography-root': {
                                fontSize: '13px',
                            },
                            // '& .MuiDataGrid-virtualScroller': {
                            //   overflow: 'auto',
                            // },
                            '& .MuiDataGrid-cell': {
                                fontSize: '13px',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                position: 'sticky',
                                top: 0,
                                zIndex: 2,
                                backgroundColor: '#fff',
                            },
                            '& .MuiDataGrid-cell.sticky-col-1': {
                                position: 'sticky',
                                left: 0,
                                background: '#fff',
                                zIndex: 2,
                            },
                            '& .MuiDataGrid-columnHeader.sticky-col-1': {
                                position: 'sticky',
                                left: 0,
                                background: '#fff',
                                zIndex: 99, // slightly higher than cell
                            },
                        }}
                    />
                </Box>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >

                    <MenuItem
                        onClick={() => {
                            handleMenuAction('Edit');
                            handleClickOpenEdit();
                        }}
                    >Edit/Add Bonus </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleMenuAction('Activate');
                            handleClickOpenActive();
                        }}
                    >
                        Activate Bonus
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleMenuAction('Deactivate');
                            handleClickOpenDeactive();
                        }}
                    >
                        Deactivate Bonus
                    </MenuItem>
                </Menu>
                <EditBonusModal openEdit={openEdit} handleCloseOpenEdit={handleCloseOpenEdit} />
                <ActiveBonusModal openActive={openActive} handleCloseOpenActive={handleCloseOpenActive} />
                <DeactiveBonusModal openDeactive={openDeactive} handleCloseOpenDeactive={handleCloseOpenDeactive} />
            </Box>
        </>
    )
}

export default ReferBonusManagement
